import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { ASSET_CDN_URL } from '../../static/constants.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultValue = {
  icon: {
    cdnUrl: ASSET_CDN_URL.ICONS
  },
  image: {
    unit: 'px',
    width: {
      x: 16,
      xs: 116,
      s: 375,
      m: 600,
      l: 800,
      xl: 1024
    }
  },
  illustration: {
    cdnUrl: ASSET_CDN_URL.ILLUSTRATIONS
  },
  getRootContainer: function getRootContainer() {
    return document.body;
  },
  getScrollableContainer: function getScrollableContainer() {
    return document.body;
  }
};
var EnvironmentContext = /*#__PURE__*/React.createContext(defaultValue);
var useEnvironmentContext = function useEnvironmentContext() {
  return React.useContext(EnvironmentContext);
};
var EnvironmentContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultValue : _ref$value;
  return /*#__PURE__*/React.createElement(EnvironmentContext.Provider, {
    value: _objectSpread(_objectSpread({}, defaultValue), value)
  }, children);
});
EnvironmentContextProvider.displayName = 'EnvironmentContextProvider';

export { EnvironmentContextProvider, defaultValue as defaultEnvironment, useEnvironmentContext };
//# sourceMappingURL=Environment.js.map
